import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { supabase } from "../shared/supabaseclient";
import Banner from "../components/allbanner";

const VideosPage = () => {
  const [videoIds, setVideoIds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchVideos = async () => {
      const { data, error } = await supabase
        .from("youtube_link")
        .select("link")
        .order("created_at", { ascending: false }); // 👈 Latest videos come first

      if (error) {
        console.error("Error fetching videos:", error.message);
      } else {
        // Extract valid YouTube video IDs
        const ids = (data || [])
          .map(({ link }) => extractYouTubeId(link))
          .filter(Boolean);
        setVideoIds(ids);
      }

      setLoading(false);
    };

    fetchVideos();
  }, []);

  // 🔍 Helper function — extract YouTube video ID from URL
  const extractYouTubeId = (url) => {
    try {
      const regex =
        /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|v\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/;
      const match = url.match(regex);
      return match ? match[1] : null;
    } catch {
      return null;
    }
  };

  return (
    <div className="bg-gray-50 min-h-screen">
      {/* ===== Banner ===== */}
      <Banner
        title="Isuzu Video Gallery"
        description="Explore our latest videos showcasing Isuzu reliability, innovation, and performance."
      />

      {/* ===== Video Grid ===== */}
      <section className="py-12 px-4 md:px-8 container mx-auto">
        {loading ? (
          <p className="text-center text-gray-500 py-10 text-lg font-medium animate-pulse">
            Loading videos...
          </p>
        ) : videoIds.length === 0 ? (
          <p className="text-center text-gray-600 py-10 text-lg">
            No videos found.
          </p>
        ) : (
          <motion.div
            initial="hidden"
            whileInView="visible"
            variants={{
              hidden: { opacity: 0, y: 40 },
              visible: { opacity: 1, y: 0 },
            }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            viewport={{ once: true }}
            className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6"
          >
            {videoIds.map((id) => (
              <motion.div
                key={id}
                whileHover={{ scale: 1.02 }}
                transition={{ duration: 0.3 }}
                className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-lg border border-gray-200"
              >
                <div className="aspect-video">
                  <iframe
                    title={`isuzu-video-${id}`}
                    src={`https://www.youtube-nocookie.com/embed/${id}`}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    loading="lazy"
                    className="w-full h-full"
                  />
                </div>
              </motion.div>
            ))}
          </motion.div>
        )}
      </section>
    </div>
  );
};

export default VideosPage;
